import { connect } from 'react-redux'
import { RootState } from 'typesafe-actions';
import { ThunkDispatch } from 'redux-thunk';
import { getSupplierProductsMappingsAsyncThunk, updateSupplierProductsMappingsAsyncThunk, sendSupplierOfferFileAsyncThunk , updatePrices} from '../actions/SupplierActions';
import SupplierMappings from '../components/SupplierMappings';
import { SupplierProductMapping } from '../../api/models/SupplierProductMapping';


const mapStateToProps = (state: RootState) => ({
    getMappingsBusy : state.supplierRdc.suppProdsMappingsBusy,
    supplierMappings: state.supplierRdc.supplierProductsMappings,
    sendSupplierOfferBusy: state.supplierRdc.sendSupplierOfferBusy,
    sendSupplierOfferSucced: state.supplierRdc.sendSupplierOfferSucced,
    updateMappingsBusy: state.supplierRdc.updateMappingsBusy,
    supplier: state.supplierRdc.supplierInfo
})

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, any>) => {
    return ({
        getSupplierMappings: async () => {
            await dispatch(getSupplierProductsMappingsAsyncThunk())
        },
        updateMapping: (m: SupplierProductMapping) => {
            dispatch(updateSupplierProductsMappingsAsyncThunk([m]))
        },
        updatePrices: (m: SupplierProductMapping) => {
            dispatch(updatePrices(m))
        },
        sendSupplierOfferFile: (file: File) => {
            dispatch(sendSupplierOfferFileAsyncThunk(file))
        },
    })
}

export type SupplierMappingsProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>

export const SupplierMappingsCnn = connect(
    mapStateToProps,
    mapDispatchToProps
)(SupplierMappings);